﻿import $ from "jquery";
export const Tooltip = {
  bind: bsTooltip,
  update: bsTooltip,
  unbind(el, binding) {
    $(el).tooltip("dispose");
  },
};

function bsTooltip(el, binding) {
  if (binding.value !== undefined) {
    //Tooltip disposen zodat na een update correct blijft functioneren
    if (binding.value !== binding.oldValue) {
      $(el).tooltip("dispose");
    }

    let trigger;
    if (
      binding.modifiers.focus ||
      binding.modifiers.hover ||
      binding.modifiers.click
    ) {
      const t = [];
      if (binding.modifiers.focus) t.push("focus");
      if (binding.modifiers.hover) t.push("hover");
      if (binding.modifiers.click) t.push("click");
      trigger = t.join(" ");
    } else {
      trigger = "hover";
    }

    let boundary = "scrollParent";
    if (
      binding.modifiers.window ||
      binding.modifiers.viewport ||
      binding.modifiers.el
    ) {
      if (binding.modifiers.window) boundary = "window";
      if (binding.modifiers.viewport) boundary = "viewport";
      if (binding.modifiers.el) boundary = el;
    }

    $(el).tooltip({
      title: binding.value || "",
      placement: binding.arg || "top",
      trigger: trigger || "hover focus",
      html: binding.modifiers.html || true,
      boundary: boundary,
    });
  }
}
